<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col>
        <items-view
          storeModule="discounts"
          titleSingle="Discount"
          titleMultiple="Discounts"
          :headers="headers"
          :default="defaultItem"
          defaultSort="created_at"
          defaultSortDesc
          noTitlePrefix
          cancel="Close"
          :deleteEnabled="false"
        >
          <template #before-search="{items}">
            <p class="body-1">
              {{items.length}} discounts
            </p>
          </template>

          <template #item.active="{item}">
            <span v-if="item.active"><v-icon>mdi-check</v-icon></span>
            <span v-else>-</span>
          </template>
          <template #item.code="{item}">
            <span>{{item.code.slice(0,2)}}***{{item.code.slice(-2)}}</span>
          </template>
          <template #item.created_at="{item}">
            <span>{{(item.created_at || '').slice(0, 16)}}</span>
          </template>

          <template #itemForm="slotProps">
            <discount-form v-bind="slotProps"></discount-form>
          </template>
        </items-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ItemsView} from 'dync-baseitem';
import DiscountForm from '../components/DiscountForm.vue';

export default {
  name: 'Discounts',
  components: {
    ItemsView,
    DiscountForm
  },
  data() {
    return {
      headers: [
        {
          text: 'Active',
          value: 'active'
        },
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'Code',
          value: 'code'
        },
        {
          text: 'Created at',
          value: 'created_at'
        }
      ],
      defaultItem: {
        active: true
      }
    };
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
